/* eslint-disable import/no-cycle */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { RefreshToken } from '@/lib/API';
import Home from '../views/app/Home';
import Store from '../store';


Vue.use( VueRouter );

const routes = [
	{
		path      : '/',
		name      : 'Login',
		component : () => import( '../views/Login' )
		 //component : () => import( '../views/app/Test' )
	},
	{
		path      : '/forgot-password',
		name      : 'Forgot Password',
		component : () => import( '../views/ForgotPassword' )
	},
	{
		path      : '/reset-password/:token',
		name      : 'Reset Password',
		component : () => import( '../views/ResetPassword' )
	},	
	{
		path      : '/test',
		name      : 'Test',
		component : () => import( '@/views/app/Test' )
	},
	{
		path      : '/app',
		name      : 'Home',
		component : Home,
		redirect  : '/app/select-contract',
		// redirect  : '/app/Test',
		children  : [
			//*
			{
				path      : 'select-contract',
				name      : 'Select Contract',
				component : () => import( '@/views/app/SelectContract' )
			},
			//*/
			/*
			{
				path      : 'select-contract',
				name      : 'Test',
				component : () => import( '@/views/Test' )
			},
			//*/
			//*
			{
				path      : 'home',
				name      : 'HomePage',
				component : () => import( '@/views/app/HomePage' )
			},
			//*/
			/*
			{
				path      : 'home',
				name      : 'Test',
				component : () => import( '@/views/Test' )
			},
			//*/
			{
				path      : 'entity-summary',
				name      : 'Entity Summary',
				component : () => import( '../views/app/EntitySummary' )
			},
			{
				path      : 'variety-summary',
				name      : 'Variety Summary',
				component : () => import( '../views/app/VarietySummary' )
			},
			{
				path      : 'field-summary',
				name      : 'Field Summary',
				component : () => import( '../views/app/FieldSummary' )
			},
			{
				path      : 'payment',
				name      : 'Payment Schedule',
				component : () => import( '../views/app/PaymentSchedule' )
			},
			// {
			// 	path      : 'email',
			// 	name      : 'Email',
			// 	component : () => import( '../views/app/Email' )
			// },
			{
				path      : 'receipt-year',
				name      : 'Receipt Year',
				component : () => import( '../views/app/ReceiptYear' )
			},
			{
				path      : 'report-selector',
				name      : 'Report Selector',
				component : () => import( '../views/app/ReportSelector' )
			},
			{
				path      : 'report-menu',
				name      : 'Report Menu',
				component : () => import( '../views/app/ReportMenu' )
			},
			{
				path      : 'reports-by-year',
				name      : 'Reports By Year',
				component : () => import( '../views/app/ReportsByYear' )
			},
			{
				path      : 'download-forms',
				name      : 'Download Forms',
				component : () => import( '../views/app/DownloadForms' )
			},
			{
				path      : 'form-menu',
				name      : 'Form Menu',
				component : () => import( '../views/app/FormMenu' )
			},
			{
				path      : 'reports',
				name      : 'Reports',
				component : () => import( '../views/app/Reports' )
			},
			{
				path      : 'receipt',
				name      : 'Receipt',
				props     : true,
				component : () => import( '../views/app/Receipt' )
			},
			{
				path      : 'receipt-statement',
				name      : 'Receipt Statement',
				component : () => import( '../views/app/ReceiptStatement' )
			},
	
		],
		beforeEnter : ( to, from, next ) => {

			const { accessToken } = Store.state;
			const { selectedContract } = Store.state;

			if ( accessToken ) {
				next();
			}

			//console.log('refresh from router');
			//console.log(from);
			//if(from.name == null || from.name!==null && from.name !== "Login") { //eslint-disable-line
			//	console.log('Do it');
			//	RefreshToken()
			//		.then( ( data ) => {
			//			console.log( data );
			//			if ( !data.accessToken ) {
			//				console.log('no refresh-token, no accessToken');
			//				next( '/' );
			//			}
			//			console.log('refresh-token success');
			//			Store.dispatch( 'setAccessToken', data );
			//			next();
			//		} )
			//		.catch( ( e ) => {
			//			console.log('refresh-token error');
			//			console.warn( e );
			//			next( '/' );
			//		} );
			//} else {
			//	console.log('SKIP IT');
			//	console.log('access token');
			//	console.log(accessToken);
			//}
			next();

		}
	}
];

const router = new VueRouter( {
	mode : 'history',
	base : process.env.BASE_URL,
	routes
} );

export default router;
